import {
  ChainId,
  isMainnet,
  mainnetChainIds,
  testnetChainIds,
} from "#/config/web3/contractAddresses";

export const isChainSupported = (chainId: ChainId) => {
  return isMainnet
    ? mainnetChainIds.includes(chainId)
    : testnetChainIds.includes(chainId);
};
